import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import AlarmsScreen from '../screens/AlarmsScreen';
import CustomAlarmTemplatesScreen from '../screens/CustomAlarmTemplatesScreen';
import GalaxyHeaderBackground from '../components/GalaxyHeaderBackground';

export type AlarmsStackParamList = {
  AlarmsList:
    | {
        severity?: 'all' | 'critical' | 'warning';
        refresh?: boolean;
      }
    | undefined;
  CustomTemplates: undefined;
};

const Stack = createNativeStackNavigator<AlarmsStackParamList>();

export default function AlarmsStackNavigator() {
  const { i18n } = useTranslation();
  const { theme } = useTheme();
  const isArabic = i18n.language === 'ar';

  return (
    <Stack.Navigator
      screenOptions={{
        headerBackground: () => <GalaxyHeaderBackground />,
        headerTintColor: '#ffffff',
        headerTitleStyle: {
          fontWeight: '600',
        },
        headerTransparent: true,
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen
        name="AlarmsList"
        component={AlarmsScreen}
        options={{
          headerShown: true,
          title: isArabic ? 'التنبيهات' : 'Alarms',
        }}
      />
      <Stack.Screen
        name="CustomTemplates"
        component={CustomAlarmTemplatesScreen}
        options={{
          headerShown: true,
          title: isArabic ? 'قوالب التنبيهات المخصصة' : 'Custom Alarm Templates',
        }}
      />
    </Stack.Navigator>
  );
}
